(function () {
  class PlCollection extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.onDocClick = (e) => {
        if (!e.target.closest('.plc__filter')) this.closeAll();
      };
      document.addEventListener('click', this.onDocClick);
      window.addEventListener('popstate', () => window.location.reload());
      this.bindInner();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocClick);
      if (this.io) this.io.disconnect();
    }

    bindInner() {
      this.form = this.querySelector('[data-plc-form]');

      this.querySelectorAll('[data-plc-toggle]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const item = btn.closest('.plc__filter');
          const isOpen = item.classList.contains('is-open');
          this.closeAll();
          if (!isOpen) item.classList.add('is-open');
        });
      });

      if (this.form) {
        this.form.addEventListener('change', (e) => {
          if (e.target.matches('[data-plc-facet]') || e.target.matches('[data-plc-sort]')) {
            this.apply();
          }
        });
      }

      this.querySelectorAll('[data-plc-range]').forEach((wrap) => this.bindRange(wrap));

      this.querySelectorAll('[data-plc-link]').forEach((a) => {
        a.addEventListener('click', (e) => {
          e.preventDefault();
          this.navigate(a.getAttribute('href'));
        });
      });

      this.bindMore();
    }

    bindMore() {
      if (this.io) {
        this.io.disconnect();
        this.io = null;
      }
      const btn = this.querySelector('[data-plc-loadmore]');
      if (btn) {
        btn.addEventListener('click', () => this.loadMore(btn.dataset.url));
      }
      const sentinel = this.querySelector('[data-plc-infinite]');
      if (sentinel) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting) this.loadMore(sentinel.dataset.url);
          });
        }, { rootMargin: '400px 0px' });
        this.io.observe(sentinel);
      }
    }

    closeAll() {
      this.querySelectorAll('.plc__filter.is-open').forEach((i) => i.classList.remove('is-open'));
    }

    bindRange(wrap) {
      const min = wrap.querySelector('[data-plc-range-min]');
      const max = wrap.querySelector('[data-plc-range-max]');
      const numMin = wrap.querySelector('[data-plc-num-min]');
      const numMax = wrap.querySelector('[data-plc-num-max]');
      const fill = wrap.querySelector('[data-plc-range-fill]');
      const labelMin = wrap.querySelector('[data-plc-label-min]');
      const labelMax = wrap.querySelector('[data-plc-label-max]');
      if (!min || !max) return;
      const ceil = parseFloat(max.max);
      const sym = wrap.dataset.symbol || '';

      const paint = () => {
        let lo = parseFloat(min.value);
        let hi = parseFloat(max.value);
        if (lo > hi) {
          const t = lo;
          lo = hi;
          hi = t;
        }
        if (fill) {
          fill.style.left = (lo / ceil) * 100 + '%';
          fill.style.right = 100 - (hi / ceil) * 100 + '%';
        }
        if (labelMin) labelMin.textContent = sym + Math.round(lo).toLocaleString();
        if (labelMax) labelMax.textContent = sym + Math.round(hi).toLocaleString();
        if (numMin) numMin.value = Math.round(lo);
        if (numMax) numMax.value = Math.round(hi);
      };

      const engage = () => {
        if (numMin) numMin.disabled = false;
        if (numMax) numMax.disabled = false;
        paint();
      };

      min.addEventListener('input', engage);
      max.addEventListener('input', engage);
      const commit = () => {
        engage();
        this.apply();
      };
      min.addEventListener('change', commit);
      max.addEventListener('change', commit);
      paint();
    }

    apply() {
      if (!this.form) return;
      const fd = new FormData(this.form);
      const params = new URLSearchParams();
      for (const [k, v] of fd.entries()) {
        if (v !== '' && v != null) params.append(k, v);
      }
      const action = this.form.getAttribute('action') || window.location.pathname;
      this.navigate(action + (params.toString() ? '?' + params.toString() : ''));
    }

    fetchUrl(u) {
      const sep = u.search ? '&' : '?';
      return u.pathname + u.search + sep + 'section_id=' + this.sectionId;
    }

    async navigate(url) {
      this.classList.add('is-loading');
      const u = new URL(url, window.location.origin);
      try {
        const res = await fetch(this.fetchUrl(u));
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fresh = doc.querySelector('[data-plc-root]');
        const current = this.querySelector('[data-plc-root]');
        if (fresh && current) {
          current.innerHTML = fresh.innerHTML;
          window.history.pushState({}, '', u.pathname + u.search);
          this.bindInner();
          const top = this.getBoundingClientRect().top + window.scrollY - 120;
          window.scrollTo({ top: top, behavior: 'smooth' });
        } else {
          window.location.href = u.pathname + u.search;
        }
      } catch (e) {
        window.location.href = u.pathname + u.search;
      } finally {
        this.classList.remove('is-loading');
      }
    }

    async loadMore(url) {
      if (!url || this.loadingMore) return;
      this.loadingMore = true;
      const btn = this.querySelector('[data-plc-loadmore]');
      if (btn) btn.textContent = btn.dataset.loading || 'Loading…';
      const u = new URL(url, window.location.origin);
      try {
        const res = await fetch(this.fetchUrl(u));
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const freshGrid = doc.querySelector('[data-plc-grid]');
        const grid = this.querySelector('[data-plc-grid]');
        if (freshGrid && grid) {
          while (freshGrid.firstElementChild) grid.appendChild(freshGrid.firstElementChild);
        }
        const freshMore = doc.querySelector('[data-plc-more]');
        const moreArea = this.querySelector('[data-plc-more]');
        if (moreArea) {
          moreArea.innerHTML = freshMore ? freshMore.innerHTML : '';
        }
        window.history.pushState({}, '', u.pathname + u.search);
        this.bindMore();
      } catch (e) {
        /* ignore */
      } finally {
        this.loadingMore = false;
      }
    }
  }

  if (!customElements.get('pl-collection')) customElements.define('pl-collection', PlCollection);
})();
